import { LitElement, html } from 'vendor/lit'
import { debounce } from 'utils/general'
class HHFiltersWrapper extends LitElement {
  constructor() {
    super()
    this._self = this
    this.pageType = this.getAttribute('page-type') || 'collection'
    this.filterData = []
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)
    this.closeDetails = this.closeDetails.bind(this)
    this.onHistoryChange = this.onHistoryChange.bind(this)
    this.closeMobileFilters = this.closeMobileFilters.bind(this)
    this.resetForm = this.querySelector('.js-reset-form')
    this.filtersWrapper = this.querySelector('.js-active-filters')
    this.filterOptions = this.querySelectorAll('input')
    this.filters = Array.from(this.querySelectorAll('input'))
      .filter((input) => input.checked)
      .map((input) => {
        if (!input.checked) return
        const { name, value, id } = input
        return { name: name, value: value, id: id }
      })

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.classList.contains('js-sort-by-clone')) {
        document
          .querySelector(`#main-${this.pageType}-filters .js-sort-input`)
          .setAttribute('data-sorted', true)
      }

      if (event.target.hasAttribute('value')) {
        this.dispatchFilterApplyEvent(event.target)
      }

      this.initColorSwatches()
      this.toggleFilters()
      this.toggleResetButton()
      this.onSubmitHandler(event)
    }, 500).bind(this)

    this.initColorSwatches()
    this.toggleResetButton()
    this.toggleFilters()
  }

  connectedCallback() {
    const submitInputs = this.querySelectorAll('.js-filter-submit')
    const sortInput = document.querySelector(
      `#main-${this.pageType}-filters .js-sort-input`
    )
    const sortInputClone = this.querySelector('.js-sort-by-clone')
    const closeButton = this.querySelector('.js-close')
    const activeFilter = this.querySelector('.js-active-filters')

    this.bindActiveFacetButtonEvents()
    window.addEventListener('popstate', this.onHistoryChange)
    // document.body.addEventListener('click', this.closeDetails)
    submitInputs.forEach((element) => {
      element.addEventListener('click', this.debouncedOnSubmit)
    })
    this.filterOptions.forEach((input) => {
      if (input.closest('.list-colors')) {
        input.addEventListener('change', (e) => this.colorSwatchAction(e))
      }

      input.addEventListener('change', this.debouncedOnSubmit)
    })

    activeFilter?.addEventListener('click', (e) => this.removeFilter(e))
    sortInput &&
      this.querySelector('.js-sort-by-clone').addEventListener(
        'change',
        this.debouncedOnSubmit
      )
    sortInput &&
      sortInput.addEventListener('change', (e) => {
        const { value } = e.detail
        sortInputClone.value = value

        sortInputClone.dispatchEvent(
          new CustomEvent('change', {
            bubbles: true,
            composed: true,
            detail: {
              value,
            },
          })
        )
      })
    closeButton?.addEventListener('click', this.closeMobileFilters)
    this.toggleCustomFilters()
    this.resetForm
      .querySelector('a')
      .addEventListener('click', this.resetFilters.bind(this))
  }

  resetFilters(e) {
    e.preventDefault()

    document.querySelectorAll('hh-filters-wrapper input').forEach((input) => {
      input.checked = false

      if (input.closest('label')?.hasAttribute('data-checked')) {
        input.closest('label')?.setAttribute('data-checked', false)
      }
    })

    this.debouncedOnSubmit(e)
  }

  dispatchFilterApplyEvent(target) {
    // Ignore unchecked checkboxes
    if (target.localName == 'input' && target.type == 'checkbox' && !target.checked) return

    const filterLabel = target.getAttribute('data-filter-label')
    const filterSelection = target.value
    document.dispatchEvent(
      new CustomEvent('filter:apply', {
        detail: {
          filterLabel,
          filterSelection,
        },
      })
    )
  }

  toggleCustomFilters() {
    Array.from(this.querySelectorAll('form .js-filter input')).forEach(
      (input) => {
        const isCustomFilter = input
          .closest('.js-filter')
          ?.getAttribute('is-custom-filter')

        if (isCustomFilter) {
          const customFilterActive = Array.from(
            this.querySelectorAll(
              `.js-filter input[has-custom-filter*="${isCustomFilter}"]`
            )
          ).some((input) => input.checked)

          const inputParent = input.closest('.js-filter')
          if (customFilterActive) {
            inputParent.classList.add('show-filter')

            inputParent.querySelectorAll('input').forEach((_input) => {
              _input.removeAttribute('disabled')
            })
          } else {
            inputParent.classList.remove('show-filter')

            inputParent.querySelectorAll('input').forEach((_input) => {
              _input.setAttribute('disabled', true)
            })
          }
        }
      }
    )
  }

  getActiveFilters() {
    return Array.from(this.querySelectorAll('input'))
      .filter((input) => input.checked)
      .map((input) => {
        if (!input.checked) return
        const { name, value, id } = input
        return { name: name, value: value, id: id }
      })
  }

  removeFilter(e) {
    const target = e.target

    if (
      target.getAttribute('data-action') !== 'remove' &&
      !target.closest('.active-filter')
    )
      return

    const name = target.getAttribute('data-name')
    const value = target.getAttribute('data-value')
    const id = target.getAttribute('data-id')

    this.querySelector(
      `input${value ? `[value="${value}"]` : ''}${
        name ? `[name="${name}"]` : ''
      }${id ? `[id="${id}"]` : ''}`
    ).click()
  }

  toggleFilters() {
    const activeFilters = this.getActiveFilters()
    if (!this.filtersWrapper) return

    const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
      <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
    </path></svg></svg>`

    let injectFilterHtml = ''
    activeFilters.forEach((filter) => {
      injectFilterHtml += `<li
        class="active-filter"
        data-id="${filter.id}"
        data-name="${filter.name}"
        data-value="${filter.value}"
        data-action="remove"
        >${
          filter.name === 'filter.v.availability'
            ? `${filter.value === '1' ? 'in stock' : 'not in stock'}`
            : filter.value
        }

        ${closeIcon}
      </li>`
    })

    this.filtersWrapper.innerHTML = injectFilterHtml
  }

  toggleResetButton() {
    const hasActiveFilter = Array.from(this.querySelectorAll('input')).some(
      (input) => input.checked
    )
    hasActiveFilter
      ? this.resetForm?.classList.remove('hidden')
      : this.resetForm?.classList.add('hidden')
    hasActiveFilter
      ? this?.classList.add('has-active-filter')
      : this?.classList.remove('has-active-filter')
  }

  async initColorSwatches() {
    const colorSwatches = this.querySelectorAll(
      '.list-colors [data-color-swatch]'
    )

    colorSwatches.forEach((swatch) => {
      let colorName = swatch.getAttribute('data-color-swatch')

      if (colorName.includes('é')) {
        colorName = colorName.replace('é', 'e')
      }

      let label = swatch.closest('label')

      if (!label.getAttribute('data-tooltip')) {
        label?.addEventListener('mouseenter', (e) =>
          this.toggleTooltip(e, colorName)
        )
        label?.addEventListener('mouseleave', (e) => this.toggleTooltip(e))

        label.setAttribute('data-tooltip', true)
      }
    })
  }

  colorSwatchAction(e) {
    const { target } = e
    const isChecked = target.checked

    target.closest('label').setAttribute('data-checked', isChecked)
    target.setAttribute('aria-checked', isChecked)
  }

  toggleTooltip(e, colorName) {
    const tooltip = this.querySelector('.filter__list__color-tooltip')

    if (e.type === 'mouseenter') {
      tooltip.classList.add('show')
      tooltip.style.setProperty(
        '--tooltip-left',
        `${e.target.offsetLeft - 6}px`
      )
      tooltip.style.setProperty(
        '--tooltip-top',
        `${e.target.offsetTop + (e.target.clientHeight + 2)}px`
      )
      tooltip.style.setProperty(
        '--tooltip-adjust',
        `${e.target.clientWidth / 2 + 6}px`
      )
      tooltip.querySelector('.color-tooltip--name span').textContent = colorName

      const tooltipClient = this.querySelector(
        '.filter__list__color-tooltip'
      ).getBoundingClientRect()

      if (tooltipClient.x <= 7) {
        tooltip.classList.add('tooltip-exceed')
      } else {
        tooltip.classList.remove('tooltip-exceed')
      }
    } else {
      tooltip.classList.remove('tooltip-exceed')
      tooltip.classList.remove('show')
    }
  }

  closeMobileFilters() {
    this.dispatchEvent(
      new CustomEvent('closeModal', {
        bubbles: true,
      })
    )
  }

  closeDetails(event) {
    const detailsElements = this.querySelectorAll('.js-filter')
    detailsElements.forEach((detailsElement) => {
      if (!detailsElement.contains(event.target)) {
        detailsElement.open = false
      }
    })
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const formData = Array.from(
      new FormData(
        event.target.name === 'sort_by'
          ? this.querySelector('form')
          : event.target.closest('form')
      )
    ).filter(function ([k, v]) {
      return v
    })

    let searchParams = ''
    if (this.pageType !== 'collection') {
      const currentSearchParams = new URLSearchParams(window.location.search)
      const query = `q=${currentSearchParams.get('q')}`
      searchParams = `${query}${
        new URLSearchParams(formData).toString() &&
        `&${new URLSearchParams(formData).toString()}`
      }`
    } else {
      searchParams = new URLSearchParams(formData).toString()
    }

    this.renderPage(searchParams, event)
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    this.toggleActiveFacets()
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString())
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document
      .getElementById(`main-${this.pageType}-filters`)
      .querySelector('.filters__loader')
      .classList.add('is-loading')

    const url =
      `${window.location.pathname}?` +
      this.getSections()
        .map((section) => `sections[]=${section.section}`)
        .join('&') +
      `&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.filterData = [...this.filterData, { html, url }]
        this.renderFilters(html, event)
        this.renderProductGrid(html)
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html
    this.renderFilters(html, event)
    this.renderProductGrid(html)
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById(
        `${this.capitalizeFirstLetter(this.pageType)}ProductGrid`
      ).innerHTML

    const counter = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.count-label').textContent

    document.getElementById(
      `${this.capitalizeFirstLetter(this.pageType)}ProductGrid`
    ).innerHTML = innerHTML

    const parent = document.getElementById(
      `${this.capitalizeFirstLetter(this.pageType)}ProductGrid`
    )

    this.querySelector(
      '.js-product-available-count .count-label'
    ).textContent = `${counter}`
  }

  renderFilters(...args) {
    this.renderSingleFormFilters(
      `#${this.capitalizeFirstLetter(this.pageType)}FiltersForm`,
      ...args
    )
    this.renderSingleFormFilters(
      `#${this.capitalizeFirstLetter(this.pageType)}FiltersFormMobile`,
      ...args
    )
  }

  renderSingleFormFilters(form, html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      `${form} .js-filter`
    )
    const matchesIndex = (element) =>
      element.dataset.index ===
      event?.target.closest('.js-filter')?.dataset.index

    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    )

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      const parentElement = document.querySelector(
        `${form} .js-filter[data-index="${element.dataset.index}"]`
      )

      parentElement.innerHTML = element.innerHTML
      parentElement.querySelectorAll('input').forEach((input) => {
        if (input.closest('.list-colors')) {
          this.initColorSwatches()
          input.addEventListener('change', (e) => this.colorSwatchAction(e))
        }
        if (input.checked) {
          input.closest('label')?.setAttribute('data-checked', true)
        } else {
          input.closest('label')?.removeAttribute('data-checked')
        }
        input.addEventListener('click', this.debouncedOnSubmit)
      })
    })

    this.renderActiveFacets(parsedHTML)
    this.toggleFilters()
    this.toggleCustomFilters()

    if (countsToRender) {
      this.renderCounts(countsToRender, event.target.closest('.js-filter'))
    }

    setTimeout(() => {
      document
        .getElementById(`main-${this.pageType}-filters`)
        .querySelector('.filters__loader')
        .classList.remove('is-loading')
    }, 500)
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.js-facets--mobile',
      '.js-facets--desktop',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    this.bindActiveFacetButtonEvents()
    this.toggleActiveFacets(false)
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.js-bubble', '.js-selected']
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector)
      const sourceElement = source.querySelector(selector)

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML =
          source.querySelector(selector).outerHTML
      }
    })
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, {
        once: true,
      })
    })
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  getSections() {
    return [
      {
        id: `main-${this.pageType}-filters`,
        section: document.getElementById(`main-${this.pageType}-filters`)
          .dataset.id,
      },
      {
        id: `main-${this.pageType}-product-grid`,
        section: document.getElementById(`main-${this.pageType}-product-grid`)
          .dataset.id,
      },
    ]
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-filters-wrapper', HHFiltersWrapper)
